import { render, staticRenderFns } from "./SuggestUserSection.vue?vue&type=template&id=087a8cf0&scoped=true&"
import script from "./SuggestUserSection.vue?vue&type=script&lang=js&"
export * from "./SuggestUserSection.vue?vue&type=script&lang=js&"
import style0 from "./SuggestUserSection.vue?vue&type=style&index=0&id=087a8cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a8cf0",
  null
  
)

export default component.exports